export default "__VITE_ASSET__c31ab33d__"